module.exports = __webpack_public_path__ + "img/saint-kitts-and-nevis.37ebc254.png";